import React from 'react';
import PropTypes from 'prop-types';
import {useSpring} from 'react-spring';
import {format} from 'd3';
import {CounterValue} from './Charts.styles';

const Counter = ({data}) => {
  const {number} = useSpring({
    number: data.next,
    from: {number: data.current},
  });

  return (
    <CounterValue>
      {number === 0 ? 0 : number.interpolate((n) => format(',.5r')(n))}
    </CounterValue>
  );
};

Counter.propTypes = {
  data: PropTypes.object,
};

export default Counter;
